import { Loader, Menu } from 'semantic-ui-react'
import { compose, withHandlers, withPropsOnChange, withState } from 'recompose'
import BackLink from '../components/BackLink'
import BottomButton from '../components/BottomButton'
import Layout from '../components/Layout'
import PropTypes from 'prop-types'
import React from 'react'
import Record from '../components/Record'
import RecordTab from './Do/Record'
import ReportTab from './Do/Report'
import VideosTab from './Do/Videos'
import _ from 'lodash'
import headerStyles from '../styles/header'
import injectSheet from 'react-jss'
import { withRouter } from 'react-router'

const doStyles = {
	tab: {
		width: '33.333333%',
		'white-space': 'nowrap',
		overflow: 'hidden'
	},
	menu: {
		height: '5em'
	},
	leftMenuItem: {
		'border-left': '0 !important'
	},
	rightMenuItem: {
		'border-right': '0 !important'
	}
}
// eslint-disable-next-line complexity
function Do({
	history,
	doExercise,
	metricAddOptions,
	loading,
	exercise,
	logs,
	metrics,
	addTagAsSelected,
	setSelectedTags,
	selectedTags,
	myTags,
	setMetric,
	removeMetric,
	exampleVideos,
	addMetric,
	saveLog,
	savingLog,
	removeLog,
	recordingVideo,
	setRecordedVideoBlobs,
	recordedVideoBlobs,
	playingRecordedVideo,
	setPlayingRecordedVideo,
	setRecordingVideo,
	classes,
	setTabFactory,
	tab
}) {
	if (loading) {
		return <Loader active inline content="Loading" />
	}

	if (recordingVideo) {
		const recordProps = {
			exercise,
			recordingCanceled: () => {
				setRecordingVideo(false)
			},
			recordingStopped: blobs => {
				setRecordedVideoBlobs(blobs)
				setRecordingVideo(false)
			}
		}
		return <Record {...recordProps} />
	}

	const recordLogProps = {
		metrics,
		addMetric,
		setMetric,
		removeMetric,
		metricAddOptions,

		addTagAsSelected,
		setSelectedTags,
		selectedTags,
		myTags,

		recordingVideo,
		setRecordingVideo,
		setRecordedVideoBlobs,
		recordedVideoBlobs,
		playingRecordedVideo,
		setPlayingRecordedVideo,

		exercise
	}
	const reportProps = {
		logs,
		metrics,
		myTags,
		exercise,
		removeLog
	}
	const videosProps = {
		exampleVideos,
		switchToRecordTab: setTabFactory('record')
	}

	return (
		<Layout.Container>
			<Layout.Sticker>
				<h2 className={classes.pageHeader}>{exercise.title}</h2>
				<BackLink to="/pick" content="Do different exercise" />

				<Menu tabular className={classes.menu}>
					<Menu.Item
						className={`${classes.tab} ${classes.leftMenuItem}`}
						icon="file text outline"
						name="My Logs"
						active={'report' === tab}
						onClick={setTabFactory('report')}
					/>
					<Menu.Item
						className={classes.tab}
						icon="video"
						name="Examples"
						active={'videos' === tab}
						onClick={setTabFactory('videos')}
					/>
					<Menu.Item
						className={`${classes.tab} ${classes.rightMenuItem}`}
						icon="edit"
						name="Record"
						active={'record' === tab}
						onClick={setTabFactory('record')}
					/>
				</Menu>
			</Layout.Sticker>
			<Layout.Viewer submitting={savingLog}>
				<div className={'record' === tab ? false : 'hidden'}>
					<RecordTab {...recordLogProps} />
				</div>
				<div className={'report' === tab ? false : 'hidden'}>
					<ReportTab {...reportProps} />
				</div>
				<div className={'videos' === tab ? false : 'hidden'}>
					<VideosTab {...videosProps} />
				</div>
			</Layout.Viewer>
			<Layout.Sticker>
				<BottomButton
					onClick={doExercise}
					content={`I did ${exercise.title}`}
					loading={savingLog}
				/>
			</Layout.Sticker>
		</Layout.Container>
	)
}
Do.propTypes = {
	history: PropTypes.object.isRequired /* compose */,
	metricAddOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
	doExercise: PropTypes.func.isRequired,
	playingRecordedVideo: PropTypes.bool.isRequired,
	setPlayingRecordedVideo: PropTypes.func.isRequired,
	setTabFactory: PropTypes.func.isRequired,
	classes: PropTypes.object,
	loading: PropTypes.bool.isRequired /* container */,
	exercise: PropTypes.shape({ title: PropTypes.string }),
	exampleVideos: PropTypes.arrayOf(PropTypes.string),
	logs: PropTypes.arrayOf(PropTypes.object),
	metrics: PropTypes.object.isRequired,
	setMetric: PropTypes.func.isRequired,
	removeMetric: PropTypes.func.isRequired,
	addMetric: PropTypes.func.isRequired,
	addTagAsSelected: PropTypes.func.isRequired,
	setSelectedTags: PropTypes.func.isRequired,
	selectedTags: PropTypes.arrayOf(PropTypes.string).isRequired,
	myTags: PropTypes.arrayOf(PropTypes.string).isRequired,
	saveLog: PropTypes.func.isRequired,
	savingLog: PropTypes.bool.isRequired,
	removeLog: PropTypes.func.isRequired,
	recordingVideo: PropTypes.bool.isRequired,
	setRecordedVideoBlobs: PropTypes.func.isRequired,
	recordedVideoBlobs: PropTypes.arrayOf(PropTypes.object),
	setRecordingVideo: PropTypes.func.isRequired,
	tab: PropTypes.string.isRequired
}

export default compose(
	withRouter,
	withHandlers({
		doExercise: props => ev => {
			ev.preventDefault()
			props.saveLog().then(() => {
				props.history.push('/pick')
			})
		}
	}),
	withPropsOnChange(['metrics'], props => ({
		metricAddOptions: _.map(
			_.filter(['lbs', 'secs', 'reps'].sort(), metric => !_.has(props.metrics, metric)),
			metric => ({
				key: metric,
				text: metric,
				value: metric
			})
		)
	})),
	withState('recordingVideo', 'setRecordingVideo', false),
	withPropsOnChange([], ({ setTab }) => ({
		setTabFactory: tab => () => setTab(tab)
	})),
	withState('playingRecordedVideo', 'setPlayingRecordedVideo', false),
	injectSheet(_.assign({}, headerStyles, doStyles))
)(Do)



// WEBPACK FOOTER //
// ./src/pages/Do.js